/**
 * DIEUKYDIEU.TV - SEARCH TEXT NORMALIZATION & HIGHLIGHT UTILITIES
 */

export function escapeHtml(str) {
    if (!str) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

export function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function removeVietnameseTones(str) {
    if (!str) return '';
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .toLowerCase()
        .trim();
}

export function highlightMatch(text, query) {
    if (!query || !query.trim()) return escapeHtml(text);
    const qClean = query.trim();
    const vowels = {
        'a': '[aàáảãạăằắẳẵặâầấẩẫậ]',
        'e': '[eèéẻẽẹêềếểễệ]',
        'i': '[iìíỉĩị]',
        'o': '[oòóỏõọôồốổỗộơờớởỡợ]',
        'u': '[uùúủũụưừứửữự]',
        'y': '[yỳýỷỹỵ]',
        'd': '[dđ]'
    };
    let pattern = '';
    for (const char of qClean) {
        const lower = char.toLowerCase();
        if (vowels[lower]) {
            pattern += vowels[lower];
        } else {
            pattern += escapeRegExp(char);
        }
    }
    try {
        const regex = new RegExp(`(${pattern})`, 'gi');
        return escapeHtml(text).replace(regex, '<mark>$1</mark>');
    } catch (_) {
        const regex = new RegExp(`(${escapeRegExp(qClean)})`, 'gi');
        return escapeHtml(text).replace(regex, '<mark>$1</mark>');
    }
}
